import {
  deleteCurrentLogo,
  redoLogo,
  scene,
  undoLogo,
  updateDecals,
  updateLogoSelect,
} from './webGL';

export function pushUndoQueue() {
  updateDecals();

  // Before resetting redoLogo, restore all actions from redoLogo back to undoLogo
  // This ensures that when user adds a new logo, the previously undone actions
  // are still available in undo history
  if (redoLogo && redoLogo.length > 0) {
    // Push all actions from redoLogo back to undoLogo to preserve undo history
    // The order in redoLogo is: [newest undone, older undone, ...]
    // We need to push them in reverse order to maintain correct timeline in undoLogo
    for (let i = redoLogo.length - 1; i >= 0; i--) {
      undoLogo.push(redoLogo[i]);
    }
    // Now clear redoLogo since we've restored all actions to undoLogo
    redoLogo.splice(0);
  }

  if (window.decals.length === 0) return;

  const logoAction = [];
  window.decals.forEach((x) => {
    // Only include logo objects, exclude text objects/pattern objects
    if (x.logo && x.logo.IsText !== true && x.logo.IsPattern !== true) {
      logoAction.push(convertLogoData(x));
    }
  });
  // Only push if there are logo objects to save
  if (logoAction.length > 0) {
    undoLogo.push(logoAction);
  }
}

export function convertLogoData(value) {
  const Position = Object.assign(
    Object.create(Object.getPrototypeOf(value?.logo?.Position)),
    value?.logo?.Position,
  );
  const Orientation = Object.assign(
    Object.create(Object.getPrototypeOf(value?.logo?.Orientation)),
    value?.logo?.Orientation,
  );
  const rotate = value.logo.Rotate;
  const scale = value.logo.Scale;
  return {
    type: 'logo',
    value,
    Position,
    Orientation,
    rotate,
    scale,
  };
}

export function doUndoLogo() {
  if (undoLogo.length === 0) return;
  if (undoLogo.length === 1) {
    const lastAction = undoLogo.pop();
    redoLogo.push(lastAction);
    let _logo = [];
    scene.children.forEach((x) => {
      // Only remove logo objects, exclude text objects
      if (x.logo != null && x.logo.IsText !== true) {
        _logo.push(x);
      }
    });
    _logo.forEach((x) => {
      scene.remove(x);
    });
    // Update window.decals to remove only logo objects, keep text objects
    window.decals = window.decals.filter((d) => !d.logo || d.logo.IsText === true);
    return;
  }
  const lastAction = undoLogo.pop();
  redoLogo.push(lastAction);
  const current = undoLogo[undoLogo.length - 1];
  syncTheDecals(current);
}

export function syncTheDecals(currentAction) {
  // Only remove logo objects from scene and window.decals, keep text objects
  window.decals.forEach((d) => {
    if (d.logo && d.logo.IsText !== true) {
      scene.remove(d);
    }
  });
  // Update window.decals to remove only logo objects
  window.decals = window.decals.filter((d) => d.logo && d.logo.IsText === true);

  // Restore logo objects from undo queue
  currentAction.forEach((d) => {
    d.value.logo.Rotate = d.rotate;
    d.value.logo.Scale = d.scale;
    d.value.logo.decalMesh = d.value;
    scene.add(d.value);
    window.decals.push(d.value);
  });
}

export function doRedoLogo() {
  if (redoLogo?.length > 0) {
    const lastAction = redoLogo.pop();
    undoLogo.push(lastAction);
    syncTheDecals(lastAction);
  }
}

export function doTheDelete() {
  if (window.currentLogo === null) return;
  if (window.currentLogo.IsText === true) return;
  if (window.currentLogo.IsPattern === true) return;

  deleteCurrentLogo();
  window.currentLogo = null;
  pushUndoQueue();
}
